export const AUDIO = "Audio";
export const QUESTION = "Question";
export const SLIDE = "Slide";
export const VIDEO = "Video";
